import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'recompose'
import Dialog from 'react-toolbox/lib/dialog'

import styles from './styles.scss'

const FileUploadDialog = (props) => {
  const {
    active,
    onEscKeyDown,
    onOverlayClick,
    children,
    title,
    actions
  } = props

  return (
    <Dialog
      active={active}
      theme={styles}
      onOverlayClick={onOverlayClick}
      onEscKeyDown={onEscKeyDown}
      title={title}
      actions={actions}
    >
      {children}
    </Dialog>
  )
}

FileUploadDialog.propTypes = {
  active: PropTypes.bool.isRequired,
  onEscKeyDown: PropTypes.func.isRequired,
  onOverlayClick: PropTypes.func.isRequired,
  children: PropTypes.node,
}

const withStyle = CSSModules(styles)
const enhance = compose(
  withStyle
)

export default enhance(FileUploadDialog)
